import {DashboardService} from 'src/app/services/dashboard.service';
import {ChartType} from "chart.js";

export class FusionChart {

    public barChartLabels = [];
    public barChartLabelsDate = [];
    public barChartType: ChartType
    public barChartLegend = true;
    public dashboardConfigs;
    public barChartData = null;
    public loading = true;

    constructor(public dashboardService: DashboardService) {
    }

    loadData(dashboardConfigs) {
        this.loading = true;
        this.barChartLabels = [];
        this.barChartLabelsDate = [];
        this.dashboardConfigs = dashboardConfigs;
        const dataMap = new Map();

        this.dashboardService.getDashboardData(this.dashboardConfigs).subscribe(dd => {
            dd.forEach(res => {
                const data = res.result;
                const resValueCol = res.valueCol;
                if (data === null) {
                    return;
                }
                data.forEach(element => {
                    const res = element._id;
                    if (res.month === null && res.year === null) {
                        if (!this.barChartLabels.includes(resValueCol)) {
                            this.barChartLabels.push(resValueCol);
                            this.barChartLabelsDate.push(resValueCol);
                        }
                    } else {
                        if (!this.barChartLabels.includes(res.month ? res.month + '/' + res.year : res.year)) {
                            this.barChartLabels.push(res.month ? res.month + '/' + res.year : res.year);
                            this.barChartLabelsDate.push(res.month ? new Date(res.year + '-' + res.month + '-01') : res.year);
                        }
                    }
                });
                this.barChartLabelsDate.sort((a, b) => a - b);
                this.barChartLabels = [];
                this.barChartLabelsDate.forEach(d => {
                    if (d !== null) {
                        if (typeof d.getMonth === 'function') {
                            this.barChartLabels.push((d.getMonth() + 1) + '/' + d.getFullYear());
                        } else {
                            this.barChartLabels.push(d);
                        }
                    }
                });
                data.forEach(element => {
                    const res = element._id;
                    let indexOfDate;
                    if (res.month === null && res.year === null) {
                        indexOfDate = this.barChartLabels.indexOf(resValueCol);
                    } else {
                        indexOfDate = this.barChartLabels.indexOf(res.month ? res.month + '/' + res.year : res.year);
                    }
                    let elem = dataMap.get((res.company != null ? res.company + ' ' : '') + (res.mineral != null ?
                        res.mineral + ' ' : '') + resValueCol);
                    if (elem) {
                        while (indexOfDate > elem.data.length) {
                            elem.data.push(0);
                        }
                        if (res.month === null && res.year === null) {
                            elem[data] = elem.data.push(this.barChartLabels.includes(resValueCol) ? (element.result * 1) : 0);
                        } else {
                            elem[data] = elem.data.push(this.barChartLabels.includes(res.month ? res.month + '/' + res.year : res.year) ?
                                (element.result * 1) : 0);
                        }
                    } else {
                        let dataArr: Array<number>;
                        dataArr = [];
                        if (res.month !== null || res.year !== null) {
                            while (indexOfDate > dataArr.length) {
                                dataArr.push(0);
                            }
                        }
                        dataArr.push(element.result);
                        elem = {
                            data: dataArr, label: this.formatLabelDate((res.company != null ? res.company + ' ' : '') + (res.mineral != null ?
                                res.mineral + ' ' : '') + resValueCol)
                        };
                        dataMap.set((res.company != null ? res.company + ' ' : '') + (res.mineral != null ?
                            res.mineral + ' ' : '') + resValueCol, elem);
                    }
                });

                this.barChartData = [];

                if (this.dashboardConfigs.chart === 'bar') {
                    const groupMap = new Map<string, number[]>();

                    dataMap.forEach(elem => {
                        const groupLabel = this.stripDateFromLabel(elem.label);
                        if (!groupMap.has(groupLabel)) {
                            groupMap.set(groupLabel, new Array(this.barChartLabels.length).fill(0));
                        }
                        const arr = groupMap.get(groupLabel);
                        this.barChartLabels.forEach((label, i) => {
                            arr[i] += elem.data[i] || 0;
                        });
                    });

                    groupMap.forEach((data, label) => {
                        this.barChartData.push({ data, label });
                    });

                } else {
                    dataMap.forEach(elem => {
                        if (elem.data[0] != null) {
                            if (this.dashboardConfigs.chart === 'stacked') {
                                this.barChartData.push({data: elem.data as Array<number>, label: elem.label + '', stack: 'a'});
                            } else if (this.dashboardConfigs.chart === 'pie') {
                                if (this.barChartData.length === 0) {
                                    this.barChartData.push({ data: [], labels: [] });
                                }
                                this.barChartData[0].data.push(elem.data.reduce((a, b) => a + b, 0));
                                this.barChartData[0].labels.push(elem.label + '');
                            } else {
                                this.barChartData.push({data: elem.data as Array<number>, label: elem.label + ''});
                            }
                        }
                    });

                    if (this.dashboardConfigs.chart === 'pie') {
                        this.barChartLabels = this.barChartData[0]?.labels || [];
                    }
                }
            });
            this.loading = false;
        }, () => {
            this.loading = false;
        });
    }

    private formatLabelDate(value: string): string {
        if (!value) return value;
        const isoMatch = value.match(/\d{4}-\d{2}-\d{2}T[\d:.Z]+/);
        if (isoMatch) {
            return value.replace(isoMatch[0], isoMatch[0].split('T')[0]);
        }
        return value;
    }

    private stripDateFromLabel(value: string): string {
        if (!value) return value;
        return value.replace(/^\d{4}-\d{2}-\d{2}\s*/, '').trim();
    }

    async asyncForEach(array, callback) {
        for (const item of array) {
            await callback(item);
        }
    }
}